<template>
  <b-card bg-variant="light">
    <div class="stats">
      <div class="stats__group">
        <div class="stats__value">{{campaign.sent||0}}</div>
        <div class="stats__label">Sent</div>
      </div>

      <div class="stats__divider">&rarr;</div>

      <div class="stats__group">
        <div class="stats__value">{{campaign.delivered||0}}</div>
        <div class="stats__label">{{getPercent('delivered')|percentage}}% Delivered</div>
      </div>

      <div class="stats__divider">&mid;</div>

      <div class="stats__group">
        <div class="stats__value">{{campaign.opened||0}}</div>
        <div class="stats__label">{{getPercent('opened')|percentage}}% Opened</div>
      </div>

      <div class="stats__divider">&mid;</div>

      <div class="stats__group">
        <div class="stats__value">{{campaign.clicked||0}}</div>
        <div class="stats__label">{{getPercent('clicked')|percentage}}% Clicked</div>
      </div>
      <div class="stats__divider">&mid;</div>

      <div class="stats__group">
        <div class="stats__value">{{campaign.spam||0}}</div>
        <div class="stats__label">{{getPercent('spam')|percentage}}% Spam</div>
      </div>

      <div class="stats__divider">&mid;</div>

      <div class="stats__group">
        <div class="stats__value">{{campaign.hard_bounce||0}}</div>
        <div class="stats__label">{{getPercent('hard_bounce')|percentage}}% Bounce</div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('campaigns', [
      'campaign'
    ]),
    getPercent() {
      return type => {
        if (this.campaign[type]) {
          return (this.campaign[type] / this.campaign['sent']) * 100
        }
        return 0
      }
    }
  },

  filters: {
    percentage(val) {
      return val ? val.toFixed(1) : 0
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~bootstrap/scss/_functions';
  @import '~bootstrap/scss/_variables';
  @import '~bootstrap/scss/mixins/_breakpoints';

  .stats {
    display: flex;

    font-size: 0.5rem;

    @include media-breakpoint-up(md) {
      font-size: 0.75rem;
    }

    @include media-breakpoint-up(lg) {
      font-size: 1rem;
    }

    &__value {
      font-size: 2em;
      font-weight: bold;
    }

    &__label {
      white-space: nowrap;
    }

    &__divider {
      margin: 0 1em;

      @include media-breakpoint-up(lg) {
        margin: 0 2em;
      }

      font-size: 2em;
    }
  }
</style>
